import React from 'react';
import TilesComponent from '../components/tiles.jsx';
import { MdPinIcon64 } from '@miljodirektoratet/md-react';

function PageOpenLayers() {
  return (
    <div className="tiles-container">
      <TilesComponent 
        heading="COG Stretched Renderer" 
        icon={<MdPinIcon64 height={64} width={64} />} 
        href="./maps/esri/cog-stretch/index.html" 
        mode="small"
      />
      <TilesComponent 
        heading="ArcGIS Imagery Timeslider" 
        icon={<MdPinIcon64 height={64} width={64} />} 
        href="./maps/esri/imagery-timeslider/index.html" 
        mode="small" 
      />
    </div>
  );
}

export default PageOpenLayers;